<template>
    <div class="about-page-wrapper">
    <Header modeType="1" />
        <div class="content-center">
            <div class="banner">
                <div class="content">
                    <!-- <img src="@/assets/images/about/about_htsk.png" alt=""> -->
                     <div class="title-1" >汇通数科</div>
                    <div class="banner-title">
                        中国广袤下沉市场人工智能创领者
                    </div>
                    <div style="color: #222222;font-size: 16px;">提供AI数智化产品、AI智能体，AI智能终端等一站式数智化与精准营销服务</div>
                </div>
            </div>
            <div class="block-01">
                <div class="content">
                    <div class="title" style="margin-top: 57px;">公司介绍</div>
                    <span class="emphasize"></span>
                    <p class="paragraph" style="margin-top: 20px;">
                        汇通数科智能科技有限公司（简称汇通数科）是中国领先的商业智能数字化技术与数字化运营服务商，<span class="emphasize">2019 年成立</span>于江苏省南京市，深耕产业数字化、数字营销，是一家<span class="emphasize">人工智能科技公司</span>。由汇通达网络股份有限公司（股票代码：9878.HK）投资控股。
                    </p>
                    <p class="paragraph">
                        以<span class="emphasize">"AI"</span>为技术基础，为<span class="emphasize">品牌商、零售商</span>提供智慧分销、智慧零售、智慧门店等<span class="emphasize">场景化技术解决方案</span>以及<span class="emphasize">终端营销与管理</span>、<span class="emphasize">金融科技等商家解决方案服务</span>，让生意更简单。
                    </p>
                    <p class="paragraph">
                        公司技术研发人员、数字营销人员超百人，且拥有丰富的行业经验。
                    </p>
                    <p class="paragraph">
                        截至 2025 年底，公司已服务超 11 万家终端零售客户、150 多家企业级客户。
                    </p>
                    <div class="img_block2">
                        <img src="@/assets/about/49F7B6A3.png" >
                    </div>
                    <p class="paragraph">
                        汇通数科作为数字化企业践行者，坚持人工智能科技创新与数据驱动客户持续成长。截至目前，拥有专利 2 项、软著 100 项 +、商标 100 项 +，荣获"国家级高新技术企业"、"江苏省软件企业"、"江苏省科技中小企业"、"南京市瞪羚企业"等数十多项殊荣，成功认定"南京市工程技术研究中心"、"中国产业互联网技术赋能先锋奖"、"数字服务创新"企业；产品及服务通过"AAA 级信用企业"、ISO9001、ISO14001、ISO45001、ISO27001 质量管理体系认证等。
                    </p>

                    <!-- 企业文化板块 -->
                    <div class="culture-section">
                        <div class="culture-intro">
                            <div class="intro-label">OUR CULTURE</div>
                            <div class="intro-text">我们的企业文化</div>
                        </div>
                        <div class="culture-content">
                            <div class="culture-row">
                                <div class="culture-item">
                                    <div class="item-number">01</div>
                                    <div class="item-body">
                                        <h3 class="item-title">目标市场</h3>
                                        <p class="item-desc">中国下沉市场</p>
                                        <p class="item-highlight">终端零售商</p>
                                        <p class="item-sub">品牌零售 / 连锁零售 / 个体零售</p>
                                    </div>
                                </div>
                                <div class="culture-item">
                                    <div class="item-number">02</div>
                                    <div class="item-body">
                                        <h3 class="item-title">运营模式</h3>
                                        <p class="item-desc">一站式 AI 数智化与精准营销服务</p>
                                        <p class="item-sub">全渠道增长 · 会员价值增长</p>
                                    </div>
                                </div>
                            </div>
                            <div class="culture-row">
                                <div class="culture-item">
                                    <div class="item-number">03</div>
                                    <div class="item-body">
                                        <h3 class="item-title">企业使命</h3>
                                        <p class="item-desc">助力客户经营提效</p>
                                        <p class="item-highlight">让生意更简单</p>
                                    </div>
                                </div>
                                <div class="culture-item">
                                    <div class="item-number">04</div>
                                    <div class="item-body">
                                        <h3 class="item-title">企业愿景</h3>
                                        <p class="item-desc">成为全球领先的商业智能服务企业</p>
                                        <p class="item-sub">人工智能科技公司</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from '@/common/util/metaInfo'

export default {
    metaInfo: metaInfo.Introduce,
    name: 'AboutUs',
    components: {
        Header,
        Footer
    },
    data() {
        return {}
    },
    mounted() {
    },
    methods: {}
}
</script>

<style lang="less" scoped>
.about-page-wrapper {
    width: 100%;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
}
.img_block{margin:0 auto;width: 900px;height: 475px;}
.img_block img{display: block;width: 100%;}
.img_block2{margin:0 auto;width: 927px;height: auto;}
.img_block2 img{display: block;width: 927px;height:331px;}
.banner {
    background: url("~@/assets/images/about/about_banner.jpg") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    height: 390px;
    padding: 112px 0;

    .content {
        width: 1200px;
        margin: 0 auto;

        img {
            display: block;
            width: 114px;
        }

        .banner-title {
            width: 392px;
            height: 33px;
            font-size: 20px;
            color: #222222;
            line-height: 28px;
            margin-top: 40px;
        }
    }

    img {
        display: block;
        width: 100%;
    }
}

.block-01 {
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .content {
        .logo {
            img {
                display: block;
                width: 355px;
                height: 120px;
                margin: 0 auto;
            }
        }
    }
}

.content {
    width: 900px;
    color: #222;
    text-align: left;

    .title {
        font-size: 30px;
        font-weight: 600;
        line-height: 40px;
    }

    .paragraph {
        font-size: 18px;
        line-height: 40px;
        margin-bottom: 40px;
        font-weight: 400;
        text-indent: 36px;
    }

    .emphasize {
        font-weight: 600;
    }

    .logo {
        text-align: center;
        margin-bottom: 80px;
    }
}

// 企业文化板块
.culture-section {
    margin: 80px 0 100px;
    padding: 64px 48px;
    background: linear-gradient(180deg, #F0F6FF 0%, #FFFFFF 100%);
    border-radius: 20px;

    .culture-intro {
        text-align: center;
        margin-bottom: 48px;

        .intro-label {
            font-size: 14px;
            font-weight: 600;
            color: #1763FF;
            letter-spacing: 4px;
            line-height: 20px;
            margin-bottom: 10px;
        }

        .intro-text {
            font-size: 30px;
            font-weight: 600;
            color: #222222;
            line-height: 42px;
        }
    }

    .culture-content {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .culture-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
    }

    .culture-item {
        display: flex;
        align-items: flex-start;
        gap: 24px;
        background: #FFFFFF;
        border: 1px solid rgba(23, 99, 255, 0.08);
        border-radius: 12px;
        padding: 32px 36px;
        box-shadow: 0px 2px 10px 0px rgba(10, 30, 69, 0.06);
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-4px);
            border-color: rgba(23, 99, 255, 0.25);
            box-shadow: 0px 10px 28px 0px rgba(23, 99, 255, 0.15);
        }

        .item-number {
            flex-shrink: 0;
            font-size: 40px;
            font-weight: 700;
            line-height: 1.1;
            background: linear-gradient(135deg, #29B5FD 0%, #1C53FD 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .item-body {
            .item-title {
                font-size: 20px;
                font-weight: 600;
                color: #222222;
                line-height: 28px;
                margin: 0 0 12px;
            }

            .item-desc {
                font-size: 16px;
                color: #595859;
                line-height: 26px;
                margin: 0 0 8px;
            }

            .item-highlight {
                font-size: 22px;
                font-weight: 700;
                color: #1763FF;
                line-height: 30px;
                margin: 0 0 8px;
            }

            .item-sub {
                font-size: 14px;
                color: #888888;
                line-height: 22px;
                margin: 0;
            }
        }
    }
}
</style>
